// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__jwg-V","buttons":"Footer_buttons__3noRc"};